import React from 'react'
import styled from 'styled-components'

import StyledSlatOuter from './StyledSlatOuter'
import StyledSlatInner from './StyledSlatInner'

export const Footer = () => {
  return (
    <FooterStyles id='contacto'>
      <StyledSlatOuter className='contact__outer'>
        <StyledSlatInner className='contact__inner'>
          <a href="/"><div className='contact__logo'/></a>
          <a href="mailto:negocios@omega.com.sv?Subject=Información%20Omega%20" className='contact__info'>
            <div className='contact__info__icon contact__info__icon--email'/>
            <div className='contact__info__text'>negocios@omega.com.sv</div>
          </a>

          <a href="tel:503-2562-1515" className='contact__info'>
            <div className='contact__info__icon contact__info__icon--phone'/>
            <div className='contact__info__text'>503-2562-1515</div>
          </a>

        </StyledSlatInner>
      </StyledSlatOuter>
    </FooterStyles>
  )
}

const FooterStyles = styled.div`
  .contact {
    &__outer {
      width: 100%;
      height: auto;
      color: ${({ theme }) => theme.white};
      font-size: 20px;
      background-color: ${({ theme }) => theme.lightBlue};
    }

    &__inner {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      margin: 0;
      @media (min-width: ${({ theme }) => theme.medium.start}) {
        margin: 0 20px;
        flex-flow: row;
      }
      @media (min-width: ${({ theme }) => theme.large.start}) {
        margin: auto;
      }
    }

    &__logo {
      width: 190px;
      height: 90px;
      background-image: url(/images/logo--omega.png);
      background-size: contain;
      background-repeat: no-repeat;
    }

    &__info {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      color: inherit;
      text-decoration: none;
      padding-left: 20px;
      :hover {
        text-decoration: underline;
      }

      @media (min-width: ${({ theme }) => theme.medium.start}) {
        padding-left: 0px;
      }

      &__icon {
        width: 40px;
        height: 40px;
        margin-right: 20px;
        background-size: contain;
        background-repeat: no-repeat;

        &--email {
          background-image: url(/svg/icon--email--white.svg);
        }

        &--phone {
          background-image: url(/svg/icon--phone-call--white.svg);
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Footer.js